__turbopack_context__.v({
  "scroll-title": "ScrollingTitle-module__6i1xfa__scroll-title",
  "scrolling-title": "ScrollingTitle-module__6i1xfa__scrolling-title",
});
